import { render, staticRenderFns } from "./monev_kecamatan.vue?vue&type=template&id=633c2ac8&"
import script from "./monev_kecamatan.vue?vue&type=script&lang=js&"
export * from "./monev_kecamatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports